import { useState } from 'react'
import { useMutation } from '@apollo/client/react'
import type { ErrorLike } from '@apollo/client'
import { graphql } from '../../gql'
import { useUser } from '../context/User'
import { getBillingPageUrl } from '../utils/urls'

export const CREATE_CUSTOMER_PORTAL_SESSION = graphql(/* GraphQL */ `
  mutation createCustomerPortalSession(
    $organizationId: OrganizationId!
    $returnURL: String!
    $cta: String
  ) {
    createCustomerPortalSession(
      input: {
        organizationId: $organizationId
        returnURL: $returnURL
        cta: $cta
      }
    ) {
      ... on CreateCustomerPortalSessionResponse {
        customerPortalSessionUrl
      }
      ... on BillingError {
        userFriendlyMessage
      }
    }
  }
`)
export type UseGetPortalSessionResponse = {
  openBillingPortal: (args: { ctaClicked: boolean; cta: string }) => void
  mutationError: ErrorLike | undefined
  errorMessage: string | null
  loading: boolean
}

export default function (): UseGetPortalSessionResponse {
  const account = useUser()
  const returnUrl = getBillingPageUrl(null)
  const openBillingPortal = ({
    ctaClicked,
    cta,
  }: {
    ctaClicked: boolean
    cta: string
  }): void => {
    if (!ctaClicked) {
      return
    }
    getCustomerPortalSession({
      variables: {
        organizationId: account.currentOrganization?.id,
        returnURL: `${returnUrl}`,
        cta,
      },
    })
  }
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [getCustomerPortalSession, { error: mutationError, loading }] =
    useMutation(CREATE_CUSTOMER_PORTAL_SESSION, {
      onCompleted(data) {
        const result = data?.createCustomerPortalSession

        if (result?.__typename === 'BillingError') {
          setErrorMessage(result.userFriendlyMessage)
        } else if (
          result?.__typename === 'CreateCustomerPortalSessionResponse'
        ) {
          window.open(result.customerPortalSessionUrl, '_self')
          setErrorMessage(null)
        }
      },
      onError(e) {
        setErrorMessage(
          `Whoops! Looks like there was a problem processing your request. Please try again. If you continue experiencing this problem, please contact us.`,
        )
        console.error(
          `There was a problem fetching the customer portal session: ${e.message}.`,
        )
      },
    })

  return {
    openBillingPortal,
    mutationError,
    errorMessage,
    loading,
  }
}
